import { useQuery } from "@tanstack/react-query";
import { Button, Modal, Spin } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import locationImg from "../../../assets/settings/Location - Img.png";
import { getAllLocations } from "../../../network/location";
import { getSalon } from "../../../network/settings";
import { queryKeys } from "../../../services/react-query/queryKeys";
import ModalMessageCantAddLocation from "../ModalMessageCantAddLocation";
import AddNewLocation from "./components/AddNewLocation";
import Branch from "./components/Branch";
import PricingPlan from "./components/PricingPlan";
import UpdateBranch from "./components/UpdateBranch";
const AboutBranches = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(0);
  const [showPricingPlan, setShowPricingPlan] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isAddNewBranch, setIsAddNewBranch] = useState(false);
  const intl = useIntl();
  const handleCancel = () => setIsAddNewBranch(false);
  const user = useSelector((state: any) => state?.user?.data?.user);

  const {
    data: locations,
    isError,
    isLoading,
  } = useQuery([queryKeys.Locations, isEdit], getAllLocations);

  const addId = (id: number) => {
    setIsEdit(true);
    setEditId(id);
  };

  const { data, isLoading: loadSalonData } = useQuery(
    [queryKeys?.listSalon],
    () => getSalon(user?.salon?.id)
  );
  const cancel = () => setIsEdit(false);
  const renderBranches = () =>
    isLoading ? (
      <Spin className="flex items-center justify-center" />
    ) : (
      locations?.data.map(
        ({ contact_number, email, name, id, business_location }: any) => (
          <Branch
            key={id}
            src={locationImg}
            id={id}
            name={name}
            phone={contact_number}
            mail={email}
            location={business_location?.City}
            setId={addId}
          />
        )
      )
    );

  const renderContent = () => {
    if (isAddNewBranch) {
      return <AddNewLocation cancel={handleCancel} />;
    }

    if (isEdit) {
      return <UpdateBranch id={editId} cancel={cancel} />;
    }
    if (showPricingPlan) {
      return (
        <PricingPlan SalonData={data} setShowPricingPlan={setShowPricingPlan} />
      );
    }
    const isSalonFreelancerAndHasBranch =
      user?.salon?.type === "freelancer" && locations?.data?.length >= 1;

    const showModalModal = () => {
      setOpenModal(true);
    };
    const handleCancelModal = () => {
      setOpenModal(false);
    };
    const locationCount = data?.data?.subscription_plan?.plan?.features.filter(
      (e: any) => e.key === "location_count"
    );

    return (
      <>
        <Modal
          width="40%"
          destroyOnClose={true}
          maskClosable={false}
          centered
          className="overflow-y-auto max-md:!w-[95%] max-xl:!w-[75%] max-w-[580px]"
          open={openModal}
          onCancel={handleCancelModal}
          footer={false}
        >
          <ModalMessageCantAddLocation
            handleCancelModal={handleCancelModal}
            setShowPricingPlan={setShowPricingPlan}
          />
        </Modal>
        <div className="flex items-center justify-between w-full mb-6">
          <h5 className="w-full text-lg font-semibold lg:mb-6">
            {intl.formatMessage({ id: "salonBranchesTitle" })}
          </h5>
          <Button
            onClick={() => {
              loadSalonData ||
              +locationCount[0]?.value > locations?.data?.length
                ? setIsAddNewBranch(true)
                : showModalModal();
            }}
            type="primary"
            className="min-w-[150px] w-fit"
            disabled={isSalonFreelancerAndHasBranch}
          >
            {intl.formatMessage({ id: "addNewBranchButton" })}
          </Button>
        </div>
        <div className="flex flex-col gap-4">{renderBranches()}</div>
      </>
    );
  };

  return <div className="py-8 px-6 bg-[#EEF0FF]">{renderContent()}</div>;
};

export default AboutBranches;
